/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientDocument } from './PatientDocument';
import {
    PatientDocumentFromJSON,
    PatientDocumentFromJSONTyped,
    PatientDocumentToJSON,
} from './PatientDocument';
import type { TaskComment } from './TaskComment';
import {
    TaskCommentFromJSON,
    TaskCommentFromJSONTyped,
    TaskCommentToJSON,
} from './TaskComment';

/**
 * 
 * @export
 * @interface ExternalReferral
 */
export interface ExternalReferral {
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    patient_first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    patient_last_name: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    patient_email: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    patient_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    patient_ohip?: string;
    /**
     * Assigned when patient registers with matching email
     * @type {string}
     * @memberof ExternalReferral
     */
    patient_id?: string;
    /**
     * Email of the healthcare provider who submitted the referral
     * @type {string}
     * @memberof ExternalReferral
     */
    submitter_email: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    referral_context: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferral
     */
    status?: ExternalReferralStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ExternalReferral
     */
    date?: number;
    /**
     * 
     * @type {Array<TaskComment>}
     * @memberof ExternalReferral
     */
    comments?: Array<TaskComment>;
    /**
     * 
     * @type {Array<PatientDocument>}
     * @memberof ExternalReferral
     */
    documents?: Array<PatientDocument>;
}


/**
 * @export
 */
export const ExternalReferralStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Rejected: 'rejected'
} as const;
export type ExternalReferralStatusEnum = typeof ExternalReferralStatusEnum[keyof typeof ExternalReferralStatusEnum];


/**
 * Check if a given object implements the ExternalReferral interface.
 */
export function instanceOfExternalReferral(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_first_name" in value;
    isInstance = isInstance && "patient_last_name" in value;
    isInstance = isInstance && "patient_email" in value;
    isInstance = isInstance && "submitter_email" in value;
    isInstance = isInstance && "referral_context" in value;

    return isInstance;
}

export function ExternalReferralFromJSON(json: any): ExternalReferral {
    return ExternalReferralFromJSONTyped(json, false);
}

export function ExternalReferralFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalReferral {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'patient_first_name': json['patient_first_name'],
        'patient_last_name': json['patient_last_name'],
        'patient_email': json['patient_email'],
        'patient_phone': !exists(json, 'patient_phone') ? undefined : json['patient_phone'],
        'patient_ohip': !exists(json, 'patient_ohip') ? undefined : json['patient_ohip'],
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'submitter_email': json['submitter_email'],
        'referral_context': json['referral_context'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(TaskCommentFromJSON)),
        'documents': !exists(json, 'documents') ? undefined : ((json['documents'] as Array<any>).map(PatientDocumentFromJSON)),
    };
}

export function ExternalReferralToJSON(value?: ExternalReferral | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'patient_first_name': value.patient_first_name,
        'patient_last_name': value.patient_last_name,
        'patient_email': value.patient_email,
        'patient_phone': value.patient_phone,
        'patient_ohip': value.patient_ohip,
        'patient_id': value.patient_id,
        'submitter_email': value.submitter_email,
        'referral_context': value.referral_context,
        'status': value.status,
        'date': value.date,
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(TaskCommentToJSON)),
        'documents': value.documents === undefined ? undefined : ((value.documents as Array<any>).map(PatientDocumentToJSON)),
    };
}

